// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import {
	MatAutocompleteModule,
	MatButtonModule,
	MatCardModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatDialogModule,
	MatExpansionModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatNativeDateModule,
	MatPaginatorModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatRadioModule,
	MatSelectModule,
	MatSnackBarModule,
	MatSortModule,
	MatTableModule,
	MatTabsModule,
	MatTooltipModule,
} from '@angular/material';
// NgBootstrap
import {NgbDropdownModule, NgbTabsetModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
// Core module
import {CoreModule} from '../../core/core.module';
// CRUD Partials
import {
	ActionNotificationComponent,
	AlertComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent,
} from './content/crud';
// Layout partials
import {
	ContextMenu2Component,
	ContextMenuComponent,
	LanguageSelectorComponent,
	NotificationComponent,
	QuickActionComponent,
	QuickPanelComponent,
	ScrollTopComponent,
	SearchDefaultComponent,
	SearchDropdownComponent,
	SearchResultComponent,
	SplashScreenComponent,
	StickyToolbarComponent,
	Subheader1Component,
	Subheader2Component,
	Subheader3Component,
	Subheader4Component,
	Subheader5Component,
	SubheaderSearchComponent,
	UserProfile2Component,
	UserProfile3Component,
	UserProfileComponent,
} from './layout';
import {
	Widget1SalesStatComponent,
	Widget9RecentActivitiesComponent,
	Widget12NewUsersComponent,
	Widget7WeeklySalesComponent,
	Widget1TasksOverviewComponent,
	Widget2NewArrivalsComponent,
	Widget3NewArrivalsAuthorsComponent,
	Widget4TodoComponent,
	Widget8TrendsComponent,
	Dropdown1Component,
	Dropdown2Component,
	Dropdown3Component,
	Dropdown4Component,
	Dropdown5Component
  } from './content/dashboard-widgets';
// General
import {NoticeComponent} from './content/general/notice/notice.component';
import {PortletModule} from './content/general/portlet/portlet.module';
// Errpr
import {ErrorComponent} from './content/general/error/error.component';
// Extra module
import {WidgetModule} from './content/widgets/widget.module';
// SVG inline
import {InlineSVGModule} from 'ng-inline-svg';
import {CartComponent} from './layout/topbar/cart/cart.component';
import { TimeLineComponent } from './content/tiles/time-line/time-line.component';
import { SearchableSelectComponent } from './content/general/searchable-select/searchable-select.component';
import { HierarchicalFiltersComponent } from './content/general/hierarchical-filters/hierarchical-filters.component';
import { SegmentedControlComponent } from './content/general/segmented-control/segmented-control.component';
import { ExpandableRowComponent } from './content/general/expandable-row/expandable-row.component';
import { LucideIconComponent } from '../../core/_components/lucide-icon/lucide-icon.component';

@NgModule({
	declarations: [
		LucideIconComponent,
		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,
		TimeLineComponent,
		ErrorComponent,
		Widget1SalesStatComponent,
	    Widget9RecentActivitiesComponent,
	    Widget12NewUsersComponent,
	    Widget7WeeklySalesComponent,
	    Widget1TasksOverviewComponent,
	    Widget2NewArrivalsComponent,
	    Widget3NewArrivalsAuthorsComponent,
	    Widget4TodoComponent,
	    Widget8TrendsComponent,
	    Dropdown1Component,
	    Dropdown2Component,
	    Dropdown3Component,
	    Dropdown4Component,
	    Dropdown5Component,
		SearchableSelectComponent,
		HierarchicalFiltersComponent,
		SegmentedControlComponent,
		ExpandableRowComponent
	],
	exports: [
		LucideIconComponent,
		WidgetModule,
		PortletModule,

		ScrollTopComponent,
		NoticeComponent,
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		AlertComponent,

		// topbar components
		ContextMenu2Component,
		ContextMenuComponent,
		QuickPanelComponent,
		ScrollTopComponent,
		SearchResultComponent,
		SplashScreenComponent,
		StickyToolbarComponent,
		Subheader1Component,
		Subheader2Component,
		Subheader3Component,
		Subheader4Component,
		Subheader5Component,
		SubheaderSearchComponent,
		LanguageSelectorComponent,
		NotificationComponent,
		QuickActionComponent,
		SearchDefaultComponent,
		SearchDropdownComponent,
		UserProfileComponent,
		UserProfile2Component,
		UserProfile3Component,
		CartComponent,

		ErrorComponent,
		Widget1SalesStatComponent,
	    Widget9RecentActivitiesComponent,
	    Widget12NewUsersComponent,
	    Widget7WeeklySalesComponent,
	    Widget1TasksOverviewComponent,
	    Widget2NewArrivalsComponent,
	    Widget3NewArrivalsAuthorsComponent,
	    Widget4TodoComponent,
	    Widget8TrendsComponent,
	    Dropdown1Component,
	    Dropdown2Component,
	    Dropdown3Component,
	    Dropdown4Component,
	    Dropdown5Component,
		SearchableSelectComponent,
		HierarchicalFiltersComponent,
		SegmentedControlComponent,
		ExpandableRowComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		PerfectScrollbarModule,
		InlineSVGModule,
		CoreModule,
		PortletModule,
		WidgetModule,
		NgApexchartsModule,
		// angular material modules
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
		MatExpansionModule,
		NgApexchartsModule,
		// ng-bootstrap modules
		NgbDropdownModule,
		NgbTabsetModule,
		NgbTooltipModule,
	],
})
export class PartialsModule {
}
